const pickCurried = props => object => {
  const picked: any = {}

  props.forEach(prop => {
    if (object[ prop ] !== undefined) {
      picked[ prop ] = (object as any)[ prop ]
    }
  })

  return picked
}

export default pickCurried



// WEBPACK FOOTER //
// ./src/utils/pick-curried.ts